import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SUBSCRIPTIONS_SAGA } from "../sagaTypes";
import { loadingAction, setSubscriptionsAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';

const request = data => {
    return fetch(`${ url }/get_subscriptions`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSubscriptions(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setSubscriptionsAction(response.subscriptions));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetSubscriptions() {
    yield takeLatest(GET_SUBSCRIPTIONS_SAGA, workerGetSubscriptions);
}